import Image from "next/image";
import React from "react";
import styled, { css } from "styled-components";
import WrewardsModal from "components/wrewards-ui-kit/Modal/WrewardsModal";

const DISCORD_SUPPORT_URL = "https://discord.com/channels/342870757279268868/1520957134442074143";

type VipTransferModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const VipTransferModal: React.FC<VipTransferModalProps> = ({ isOpen, onClose }): JSX.Element => {
  return (
    <WrewardsModal
      isOpen={isOpen}
      onClose={onClose}
      size="3xl"
      bodyStyle={css`
        background: #131620;
      `}
      content={
        <Root>
          <LogoWrapper>
            <Image
              src="/images/GamdomBonus/wrew-gam-logo.png"
              width={400}
              height={42}
              alt="WRewards x Gamdom"
            />
          </LogoWrapper>

          <p>
            If you are currently under another user&apos;s code on another casino, you may be
            eligible for <b>transferrable bonuses</b>. To establish eligibility and information,
            please create a ticket in the{" "}
            <a href={DISCORD_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
              discord support channel
            </a>
            .
          </p>

          <SectionDivider>
            <span>EXTRA BENEFITS</span>
          </SectionDivider>

          <SubHeading>
            <b>Leaderboard &amp; Rewards</b>
          </SubHeading>

          <p>
            By using code <b>WGTV / WatchGamesTV</b> on Gamdom, you are eligible for Rewards such as
            our Monthly <b>$100,000 Leaderboard</b> with the top prize being <b>$40,000</b>. Code
            users can earn Promo Codes which will grant you <b>Free Spins</b> and{" "}
            <b>Daily Reloads</b>.
          </p>

          <p>Note: Each promo code has set requirements on eligibility to redeem them.</p>

          <p>
            Code users are eligible for our daily Calendar for <b>Free Spins</b> and <b>WPoints</b>{" "}
            to redeem on our <b>Points Shop &amp; Raffles</b>.
          </p>

          <SubHeading>
            <b>Weekly VIP Spins in discord</b>
          </SubHeading>

          <p>
            For eligible VIP players, we offer weekly VIP spins every Sunday with values up to{" "}
            <b>$150-200</b>. We offer additional chances to win <b>HIGHER VALUED</b> spins on top of
            spins you are guaranteed to receive with values up to <b>$500</b> worth of{" "}
            <b>$10 spins</b>.
          </p>

          <CtaLink href={DISCORD_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
            MAKE A TICKET
          </CtaLink>
        </Root>
      }
    />
  );
};

export default VipTransferModal;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: var(--font-family-golos), sans-serif;
  color: #e9f4ffbf;
  font-size: 16px;
  line-height: 150%;

  p {
    margin: 0;
  }

  b {
    color: #10b67b;
  }

  a {
    color: #10b67b;
    text-decoration: underline;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const SectionDivider = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &::before {
    content: "";
    height: 1px;
    position: absolute;
    top: 50%;
    width: 100%;
    background: #e9f4ff1a;
  }

  span {
    position: relative;
    padding: 0 16px;
    background: #131620;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

const SubHeading = styled.h6`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.02em;
`;

const CtaLink = styled.a`
  padding: 16px;
  width: 100%;
  background: linear-gradient(236.31deg, #00ff86 -3.97%, #059232 87.84%);
  box-shadow: 0px 3px 0px 0px #0a4908;
  border: 0;
  border-radius: 6px;
  text-transform: uppercase;
  font-family: var(--font-family-golos), sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  && {
    color: #13171f;
    text-decoration: none;
  }

  &:hover {
    opacity: 0.8;
    color: #13171f;
  }

  &:active {
    opacity: 0.7;
    box-shadow: 0px 2px 0px 0px #0a4908;
  }
`;
